module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_12.61fb7296.jpg";